import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'

import App from './components/App'
import Login from './components/Login'
import TopsApp from './components/TopsApp'
import store from './state/store'
import { fetchCurrentUser } from './state/actions/account'
import { installSentry } from './services/sentry'
import tokenStorage from './services/token-storage'
import './index.css'
import './styles/rich-text-editor.js'

injectTapEventPlugin()
installSentry()

if (tokenStorage.get()) {
  store.dispatch(fetchCurrentUser())
}
const AppBuild = app => process.env.REACT_APP_IS_TOPS
  ? <Route path="/" component={app} />
  : (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/" component={app} />
    </Switch>
  )

const app = document.getElementById('app')

const render = Component => ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider>
      <BrowserRouter>
        {AppBuild(Component)}
      </BrowserRouter>
    </MuiThemeProvider>
  </Provider>,
  app,
)

process.env.REACT_APP_IS_TOPS ? render(TopsApp) : render(App)

if (module.hot && process.env.NODE_ENV !== 'production' && !process.env.REACT_APP_IS_TOPS) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default
    render(NextApp)
  })
}



// WEBPACK FOOTER //
// ./src/index.js